import {
  // SHIPMENTS
  FETCH_SHIPMENTS,
  FETCH_SHIPMENT,
  CREATE_SHIPMENT,
  FETCH_DESTINATIONS,
  // PACKAGES
  FETCH_PACKAGE_TYPES,
  CREATE_PACKAGE,
  DELETE_PACKAGE,
  ADD_PACKAGE_TO_STATE,
  DELETE_PACKAGE_FROM_STATE,
  ADD_ITEM_TO_PACKAGE,
  DELETE_ITEM_FROM_PACKAGE,
  // RETURNS
  CREATE_RETURN,
  FETCH_RETURN,
  FETCH_RETURNS,
  FETCH_RETURN_CATEGORIES,
} from "./types";

import { ITEMS_PER_PAGE } from "../../constants/constants";
import _ from "lodash";

const INITIAL_STATE = {
  shipmentList: {
    shipments: [],
    pages: undefined,
    error: null,
    loading: false,
  },
  createEditShipment: {
    shipment: undefined,
    error: null,
    loading: false,
  },
  destinationsList: {
    destinations: [],
    loading: false,
    error: null,
  },
  packageTypes: {
    typesList: undefined,
    error: null,
    loading: false,
  },
  createDeletePackage: {
    error: null,
    loading: false,
  },
  returnDetail: {
    returnDetail: null,
    loading: false,
    error: null,
  },
  returnList: {
    returns: [],
    loading: false,
    pages: undefined,
    error: null,
  },
  returnCategoriesList: {
    categories: [],
    loading: false,
    error: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --------------------------------------------------------------------------
    // FETCH_SHIPMENTS
    // --------------------------------------------------------------------------
    case FETCH_SHIPMENTS.init:
      return {
        ...state,
        shipmentList: { ...state.shipmentList, error: null, loading: true },
      };
    case FETCH_SHIPMENTS.success:
      return {
        ...state,
        shipmentList: {
          ...state.shipmentList,
          shipments: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_SHIPMENTS.failure:
      return {
        ...state,
        shipmentList: {
          ...state.shipmentList,
          shipments: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_SHIPMENT
    // --------------------------------------------------------------------------
    case FETCH_SHIPMENT.init:
      return {
        ...state,
        createEditShipment: { ...state.createEditShipment, error: null, loading: true },
      };
    case FETCH_SHIPMENT.success:
      return {
        ...state,
        createEditShipment: { ...state.createEditShipment, shipment: action.payload, error: null, loading: false },
      };
    case FETCH_SHIPMENT.failure:
      return {
        ...state,
        createEditShipment: {
          ...state.createEditShipment,
          shipment: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CREATE_SHIPMENT
    // --------------------------------------------------------------------------
    case CREATE_SHIPMENT.init:
      return {
        ...state,
        createEditShipment: { ...state.createEditShipment, error: null, loading: true },
      };
    case CREATE_SHIPMENT.success:
      return {
        ...state,
        createEditShipment: { ...state.createEditShipment, shipment: action.payload, error: null, loading: false },
      };
    case CREATE_SHIPMENT.failure:
      return {
        ...state,
        createEditShipment: {
          ...state.createEditShipment,
          shipment: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_DESTINATIONS
    // --------------------------------------------------------------------------
    case FETCH_DESTINATIONS.init:
      return {
        ...state,
        destinationsList: { ...state.destinationsList, error: null, loading: true },
      };
    case FETCH_DESTINATIONS.success:
      return {
        ...state,
        destinationsList: { ...state.destinationsList, destinations: action.payload.results, error: null, loading: false },
      };
    case FETCH_DESTINATIONS.failure:
      return {
        ...state,
        destinationsList: {
          ...state.destinationsList,
          destinations: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_PACKAGE_TYPES
    // --------------------------------------------------------------------------
    case FETCH_PACKAGE_TYPES.init:
      return {
        ...state,
        typesList: { ...state.packageTypes, error: null, loading: true },
      };
    case FETCH_PACKAGE_TYPES.success:
      return {
        ...state,
        packageTypes: { ...state.packageTypes, typesList: action.payload.results, error: null, loading: false },
      };
    case FETCH_PACKAGE_TYPES.failure:
      return {
        ...state,
        packageTypes: {
          ...state.packageTypes,
          typesList: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CREATE_PACKAGE
    // DELETE_PACKAGE
    // --------------------------------------------------------------------------
    case CREATE_PACKAGE.init:
    case DELETE_PACKAGE.init:
      return {
        ...state,
        createDeletePackage: {
          error: null,
          loading: true,
        },
      };
    case CREATE_PACKAGE.success:
    case DELETE_PACKAGE.success:
      return {
        ...state,
        createDeletePackage: {
          error: null,
          loading: false,
        },
      };
    case CREATE_PACKAGE.failure:
    case DELETE_PACKAGE.failure:
      return {
        ...state,
        createDeletePackage: {
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // ADD_PACKAGE_TO_STATE
    // --------------------------------------------------------------------------
    case ADD_PACKAGE_TO_STATE:
      return {
        ...state,
        createEditShipment: {
          ...state.createEditShipment,
          shipment: { ...state.createEditShipment.shipment, packages: [...state.createEditShipment.shipment.packages, action.payload] },
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // DELETE_PACKAGE_FROM_STATE
    // --------------------------------------------------------------------------
    case DELETE_PACKAGE_FROM_STATE:
      const pIndex = state.createEditShipment.shipment.packages.findIndex((elem) => elem.id === action.payload);
      return {
        ...state,
        createEditShipment: {
          ...state.createEditShipment,
          shipment: {
            ...state.createEditShipment.shipment,
            packages: state.createEditShipment.shipment.packages.filter((i, idx) => pIndex !== idx),
          },
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // ADD_ITEM_TO_PACKAGE
    // --------------------------------------------------------------------------
    case ADD_ITEM_TO_PACKAGE:
      const packagesAddItem = state.createEditShipment.shipment.packages;
      // Search package
      const indexToAdd = packagesAddItem.findIndex((elem) => elem.id === action.payload.packageId);
      // Add item
      if (indexToAdd > -1) {
        action.payload.items.forEach((item) => packagesAddItem[indexToAdd].items.push(item))
      }
      return {
        ...state,
        createEditShipment: {
          ...state.createEditShipment,
          shipment: { ...state.createEditShipment.shipment, packages: packagesAddItem },
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // DELETE_ITEM_FROM_PACKAGE
    // --------------------------------------------------------------------------
    case DELETE_ITEM_FROM_PACKAGE:
      const packagesDeleteItem = state.createEditShipment.shipment.packages;
      const index = packagesDeleteItem.findIndex((elem) => elem.id === action.payload.packageId);
      if (index > -1) {
        packagesDeleteItem[index].items = packagesDeleteItem[index].items.filter((i, idx) => i.id !== action.payload.itemID);
      }
      return {
        ...state,
        createEditShipment: {
          ...state.createEditShipment,
          shipment: { ...state.createEditShipment.shipment, packages: packagesDeleteItem },
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CREATE_RETURN
    // FETCH_RETURN
    // --------------------------------------------------------------------------
    case CREATE_RETURN.init:
    case FETCH_RETURN.init:
      return {
        ...state,
        returnDetail: { ...state.returnDetail, error: null, loading: true },
      };
    case CREATE_RETURN.success:
    case FETCH_RETURN.success:
      return {
        ...state,
        returnDetail: { ...state.returnDetail, returnDetail: action.payload, error: null, loading: false },
      };
    case CREATE_RETURN.failure:
    case FETCH_RETURN.failure:
      return {
        ...state,
        returnDetail: {
          ...state.returnDetail,
          returnDetail: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_RETURNS
    // --------------------------------------------------------------------------
    case FETCH_RETURNS.init:
      return {
        ...state,
        returnList: { ...state.returnList, error: null, pages: undefined, loading: true },
      };
    case FETCH_RETURNS.success:
      return {
        ...state,
        returnList: {
          ...state.returnList,
          returns: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_RETURNS.failure:
      return {
        ...state,
        returnList: {
          ...state.returnList,
          returns: null,
          pages: undefined,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_RETURN_CATEGORIES
    // --------------------------------------------------------------------------
    case FETCH_RETURN_CATEGORIES.init:
      return {
        ...state,
        returnCategoriesList: { ...state.returnCategoriesList, categories: [], error: null, loading: true },
      };
    case FETCH_RETURN_CATEGORIES.success:
      return {
        ...state,
        returnCategoriesList: {
          categories: action.payload.results,
          error: null,
          loading: false,
        },
      };
    case FETCH_RETURN_CATEGORIES.failure:
      return {
        ...state,
        returnCategoriesList: {
          categories: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    default:
      return state;
  }
};
